import React from 'react';

const Header = ({ logo, searchQuery, onSearchChange, activeCategory, onCategoryChange }) => {
  const categories = [
    { id: 'all', label: 'All Tools' },
    { id: 'merge', label: 'Merge & Split' },
    { id: 'convert', label: 'Convert' },
    { id: 'edit', label: 'Edit' },
    { id: 'security', label: 'Security' },
    { id: 'analyze', label: 'Analyze' },
  ];

  return (
    <header className="amazon-header">
      <div className="header-main">
        <a href="/" className="header-logo">
          <img src={logo} alt="Awesome PDF Tools" />
        </a>

        <div className="search-container">
          <input
            type="text"
            className="search-input"
            placeholder="Search PDF tools..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          <button className="search-btn" aria-label="Search">
            <svg viewBox="0 0 24 24">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
          </button>
        </div>
      </div>

      <div className="category-pills">
        {categories.map((cat) => (
          <button
            key={cat.id}
            className={`category-pill ${activeCategory === cat.id ? 'active' : ''}`}
            onClick={() => onCategoryChange(cat.id)}
          >
            {cat.label}
          </button>
        ))}
      </div>
    </header>
  );
};

export default Header;
